import React, { Component } from 'react';
import IIndustry, { TIndustry } from './IIndustry';
import { IGetStringKey } from '@appInterfaces/general.types';

const isEqual = require('lodash.isequal');

import * as style from './IndustryStyles.module.scss'
import * as appStyle from '../../AppStyle.module.scss';

const industries: string[] = [
  'none',
  'personal',
  'friends',
  'crowdfunding',
  'equity_crowdfunding',
  'angel',
  'loan',
  'vc',
  'government',
  'bnkToTheFuture',
  'other',
];

const industriesNames:IGetStringKey = {
  none: 'None',
  personal: 'Personal',
  friends: 'Friends',
  crowdfunding: 'Crowdfunding',
  equity_crowdfunding: 'Equity Crowdfunding',
  angel: 'Angel Investors',
  loan: 'Loan',
  vc: 'Venture Capital',
  government: 'Government Grant',
  bnkToTheFuture: 'BnkToTheFuture',
  bnktothefuture: 'BnkToTheFuture',
  other: 'Other',
};

const markets: string[] = [
  'Blockchain',
  'Payments & Money Transfers',
  'Consumer Banking',
  'Exchange',
  'RegTech',
  'Utility tokens',
  'Other',
];

export default class IndustryComponent extends Component<IIndustry, TIndustry> {

  state: TIndustry = {
    industries: this.props.industries || [],
    excluded: this.props.industries || [],
  };

  UNSAFE_componentWillReceiveProps(nextProps: IIndustry) {
    if (nextProps.industries && !isEqual(nextProps.industries, this.state.industries)) {
      this.setState({
        industries: nextProps.industries,
        excluded: nextProps.industries,
      });
    }
  }

  componentDidUpdate(prevProps: IIndustry, prevState: TIndustry) {
    if (!isEqual(prevState.industries, this.state.industries)) {
      if (this.props.updateStateFromChild) this.props.updateStateFromChild('markets', this.state.industries);
      if (this.props.getIndustries) this.props.getIndustries(this.state.industries);
    }
  }

  renderSelect() {
    const array = this.props.markets ? markets : industries;
    return (
      <div className={!this.props.markets ? style.wrapper : [style.wrapper, style.markets].join(' ')}>
        <label className={style.label}>
          <select
            className={style.select}
            onChange={e => this.selectChange(e)}
            defaultValue={''}
          >
            <option
              disabled={false}
              hidden={false}
              value={''}
            >
              Select {this.props.markets ? 'Market' : 'Funding to Date'}
            </option>
            {array.map((industry, index) => {
              return (
                !this.state.excluded.includes(industry) ?
                  <option key={industry} value={industry}>
                    {this.props.markets ? industry : industriesNames[industry]}
                  </option> :
                  null
              );
            })}
          </select>
        </label>
        {this.renderEditIndustiesList()}
      </div>
    );
  }

  selectChange(e: React.BaseSyntheticEvent) {
    const value = e.target.value;
    if (this.state.industries.includes(value) || value === '') return;

    this.setState({
      industries: [...this.state.industries, value],
      excluded: [...this.state.excluded, value],
    });
  }

  removeIndustry(selectedIndustry:string) {
    this.setState({
      industries: this.state.industries.filter(
        (el) => {return el.toLocaleLowerCase() !== selectedIndustry.toLocaleLowerCase();}
      ),
      excluded: this.state.excluded.filter(
        (el) => {return el.toLocaleLowerCase() !== selectedIndustry.toLocaleLowerCase();}
      ),
    });
  }

  renderEditIndustiesList() {
    const listClass = !this.props.markets ?
      style.industriesEditableList :
      [style.industriesEditableList, style.marketsEditableList].join(' ');
    return (
      <ul className={listClass}>
        {this.state.industries.map((industry, index) => {
          return (
            <li key={industry} className={style.industriesEditableListElement}>
              {this.props.markets ? industry : industriesNames[industry]}
              <button
                className={appStyle.cancelButton}
                onClick={() => this.removeIndustry(industry)}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  renderIndustiesList() {
    const listClass = !this.props.markets ?
    style.industriesList :
    [style.industriesList, style.marketsList].join(' ');
    return this.state.industries.length > 0 ? (
      <ul className={listClass}>
        {this.state.industries.map((industry, index) => {
          return (
            <li key={industry} className={style.industriesListElement}>
              {this.props.markets ? industry : industriesNames[industry]}
            </li>
          );
        })}
      </ul>
    ) : null;
  }

  renderEditMode() {
    return (
      <React.Fragment>
        {this.renderSelect()}
      </React.Fragment>
    );
  }

  renderComponent() {
    let resultHtml = this.renderIndustiesList();

    if (this.props.editMode) {
      resultHtml = this.renderEditMode();
    }
    return resultHtml;
  }

  render() {
    return (
      <React.Fragment>
        {this.renderComponent()}
      </React.Fragment>
    );
  }
}
